// Consentimiento de cookies. GTM no se carga hasta que la persona acepta: el contenedor
// trae GA4, Google Ads, el píxel de Meta y el de TikTok, y este último es HTML propio que
// el modo de consentimiento de Google no frena. Si se suma una etiqueta en GTM, queda
// cubierta sola.
const CLAVE = 'awna-cookies';
const ID_GTM = 'GTM-K8ZVZCR3';
// Cambiarla vuelve a preguntar a todos: para cuando cambien las etiquetas o la política
const VERSION = 1;
// Una decisión guardada no dura para siempre: a los 6 meses se vuelve a preguntar
const VIGENCIA_MS = 182 * 24 * 60 * 60 * 1000;

// Las cookies que dejan las etiquetas del contenedor
const COOKIES_DE_TERCEROS = /^(_ga|_gid|_gat|_gcl|_fbp|_fbc|_ttp|_tt_|ttcsid)/;

const EVENTO = 'awna:cookies';
const EVENTO_ABRIR = 'awna:cookies-abrir';

let gtmCargado = false;

function leer() {
    try {
        const guardada = JSON.parse(localStorage.getItem(CLAVE));
        if (!guardada || guardada.version !== VERSION) return null;
        if (Date.now() - guardada.fecha > VIGENCIA_MS) return null;
        return guardada.decision;
    } catch {
        // Sin localStorage no se puede recordar: se trata como si no hubiera decidido
        return null;
    }
}

/** 'aceptadas', 'rechazadas' o null si todavía no decide. */
export const decisionCookies = () => leer();

function cargarGTM() {
    if (gtmCargado) return;
    gtmCargado = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${ID_GTM}`;
    document.head.appendChild(script);
}

function borrarCookiesDeTerceros() {
    // Se prueba en cada nivel del dominio: _ga queda en .awna.cl aunque estemos en www
    const partes = window.location.hostname.split('.');
    const dominios = [''];
    for (let i = 0; i < partes.length - 1; i += 1) dominios.push(`; domain=.${partes.slice(i).join('.')}`);

    document.cookie.split(';').forEach((c) => {
        const nombre = c.split('=')[0].trim();
        if (!COOKIES_DE_TERCEROS.test(nombre)) return;
        dominios.forEach((d) => {
            document.cookie = `${nombre}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d}`;
        });
    });
}

/** Corre una vez al cargar el sitio: si ya aceptó, GTM parte como siempre. */
export function iniciarCookies() {
    if (leer() === 'aceptadas') cargarGTM();
}

export function decidirCookies(decision) {
    const anterior = leer();
    try {
        localStorage.setItem(CLAVE, JSON.stringify({ decision, version: VERSION, fecha: Date.now() }));
    } catch {
        // Sin localStorage la decisión vale solo para esta página
    }
    window.dispatchEvent(new Event(EVENTO));

    if (decision === 'aceptadas') {
        cargarGTM();
        return;
    }
    borrarCookiesDeTerceros();
    // Las etiquetas ya cargadas siguen corriendo hasta recargar: la única forma de frenarlas
    if (gtmCargado || anterior === 'aceptadas') window.location.reload();
}

export function abrirPreferenciasCookies() {
    window.dispatchEvent(new Event(EVENTO_ABRIR));
}

export function escucharPreferencias(alAbrir) {
    window.addEventListener(EVENTO_ABRIR, alAbrir);
    return () => window.removeEventListener(EVENTO_ABRIR, alAbrir);
}

/**
 * Evento para GTM, solo si aceptó. Sin este filtro quedaría en la cola de dataLayer y
 * GTM lo procesaría si la persona acepta después, en la misma página.
 */
export function eventoGTM(evento) {
    if (leer() !== 'aceptadas' && !gtmCargado) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
}
